export default {
  close: 'Zavrieť',
  save: 'Odoslať',
  search: 'Vyhľadávanie',
  reservation: 'Rezervácia',
  dataIterator: {
    pageText: '{0}-{1} z {2}',
    noResultsText: 'Neboli nájdené žiadne záznamy',
    loadingText: 'Načítavam záznamy...',
  },
  dataTable: {
    itemsPerPageText: 'Záznamov na stránku:',
    ariaLabel: {
      sortDescending: ': Zoradené zostupne.',
      sortAscending: ': Zoradené vzostupne.',
      sortNone: ': Nezoradené',
    },
  },
  dataFooter: {
    itemsPerPageText: 'Záznamov na stránku:',
    itemsPerPageAll: 'Všetky',
    nextPage: 'Ďalšia strana',
    prevPage: 'Predchádzajúca strana',
    firstPage: 'Prvá strana',
    lastPage: 'Posledná strana',
  },
  datePicker: {
    itemsSelected: '{0} vybraných',
  },
  noDataText: 'Žiadne záznamy',
  carousel: {
    prev: 'Predchádzajúce',
    next: 'Nasledovné',
  },
  calendar: {
    moreEvents: '{0} ďalších',
  },
  users: {
    new: 'Nový',
  },
  issues: {
    new: 'Nová nezhoda',
  },
  contacts: {
    title: 'Kontakty',
    new: 'Nový kontakt',
  },
  enums: {
    title: 'Číselníky',
    new: 'Nový číselník',
  },
  crud: {

  },
  orders: {
    new: 'Nová objednávka',
  },
};
